import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import FerryBookingService from "../../services/ferrybooking.service"; 

export const ferrySearch = createAsyncThunk(
  "ferry/ferrySearch",
  async (item, thunkApi) => {
    try {
      const data = await FerryBookingService.ferrySearch(item);
      return { ferry: data }; // property name
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue({ message });
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  ferry: [],
  travelPackagePrice: null,   
};

const ferrySlice = createSlice({ 
  name: "ferry",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(ferrySearch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ferrySearch.fulfilled, (state, action) => {
        state.loading = false;
        state.travelPackagePrice = action.payload.travelPackagePrice; 
      })
      .addCase(ferrySearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching data";
      });
  },
});

export default ferrySlice.reducer;
